import { render, staticRenderFns } from "./pianificaDashboard.vue?vue&type=template&id=386944a6&scoped=true&"
import script from "./pianificaDashboard.vue?vue&type=script&lang=js&"
export * from "./pianificaDashboard.vue?vue&type=script&lang=js&"
import style0 from "./pianificaDashboard.vue?vue&type=style&index=0&id=386944a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386944a6",
  null
  
)

export default component.exports